import { useEffect, useState } from "react";
import { Helmet } from "react-helmet"
import Cookies from 'js-cookie'

/**
@example
  // This function creates visitors and accounts in Pendo 
  // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> 
with values you use in your app 
  // Please use Strings, Numbers, or Bools for value types. 
  pendo.initialize({ 
      visitor: { 
          id:              <visitor-id-goes-here> // Required if user is logged 
in 
          // email:        // Recommended if using Pendo Feedback, or NPS Email 
          // full_name:    // Recommended if using Pendo Feedback 
          // role:         // Optional 

          // You can add any additional visitor level key-values here, 
          // as long as it's not one of the above reserved names. 
      }, 

      account: { 
          id:              <account-id-goes-here> // Highly recommended, 
required if using Pendo Feedback or OEM Adopt 
          // name:         // Optional 
          // is_paying:    // Recommended if using Pendo Feedback 
          // monthly_value:// Recommended if using Pendo Feedback 
          // planLevel:    // Optional 
          // planPrice:    // Optional 
          // creationDate: // Optional 

          // You can add any additional account level key-values here, 
          // as long as it's not one of the above reserved names. 
      } 
  }); 
*/
export default () => {
  const userId = Cookies.get('loggedInUserId');
  
  const isDevMode = (window.location.host.indexOf('localhost') > -1)
  const isTestScriptsOnly = isDevMode

  const [visitor, setVisitor] = useState()
  const [account, setAccount] = useState()

  useEffect(() => {
    setVisitor(userId ? { id: userId } : {}) // Empty object will track as an anonymous user (Pendo uses local storage)
    setAccount()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  return (
    <Helmet>
      <script>{
visitor && `
${isTestScriptsOnly ? 
`
(function() {
  window.pendo = {
    initialize: (params) => {
      console.log('Pendo fake initialization while in DevMode with the following params: ' + JSON.stringify(params))
    }
  }
})()
` : `
(function(publicAppId){ 
  (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[]; 
  v=['initialize','identify','updateOptions','pageLoad','track','trackAgent'];for(w=0,x=v.length;w<x;++w)(function(m){      
  o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);     
  y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+publicAppId+'/pendo.js';  
  z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo'); 
})('4187a4a1-4d03-4e55-91ef-d371e468b5ee'); 
`}

window.pendo.initialize({
  visitor: ${JSON.stringify(visitor)},
  account: ${account ? JSON.stringify(account) : 'undefined'}
});
`
      }</script>
    </Helmet>
  )
}